import { render, staticRenderFns } from "./route-info-v2.vue?vue&type=template&id=5d6bc09b&"
import script from "./route-info-v2.vue?vue&type=script&lang=ts&"
export * from "./route-info-v2.vue?vue&type=script&lang=ts&"
import style0 from "./route-info-v2.vue?vue&type=style&index=0&id=5d6bc09b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports